export const FORGET_USER = 'login_user';
export const FORGET_USER_SUCCESSFUL = 'forget_user_successfull';

export const RESET_PASSWORD = "RESET_PASSWORD"

export const FORGET_PASSWORD_API_FAILED = 'FORGET_PASSWORD_API_FAILED';

export const RESET_FORGET_USER ='RESET_FORGET_USER'

export const IS_LOADING ='IS_LOADING'